"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DiscountRow = void 0;
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _FormattedMessage = require("../FormattedMessage");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(3),
        gridColumnEnd: -1,
        gridColumnStart: 1
    };
});
const Badge = (0, _mui.styled)(_shared.Badge)(()=>({
        position: 'static'
    }));
const DiscountRow = (param)=>{
    let { countProducts, discount } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        "data-testid": getTestId('discount-row'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Badge, {
                ownerState: {
                    isIcon: false
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_culture.FormatPercent, {
                    options: {
                        decimals: _culture.Decimals.None
                    },
                    children: discount
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                variant: "body1",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                    id: "chooseProductsToDiscount",
                    values: {
                        0: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                            component: "span",
                            fontWeight: "bold",
                            children: countProducts
                        }),
                        1: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                            component: "span",
                            fontWeight: "bold",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_culture.FormatPercent, {
                                options: {
                                    decimals: _culture.Decimals.None
                                },
                                children: discount
                            })
                        })
                    }
                })
            })
        ]
    });
};
exports.DiscountRow = DiscountRow;
